import { Divider } from 'antd'
import React from 'react'
import TimelineSkeleton from './TimelineSkeleton';
import '../../../styles/components/MarketPlace/skeletons/JobApplicationStatusContainerSkeleton.scss';

function JobApplicationStatusContainerSkeleton() {
  return (
    <div className='job-application-status-skeleton'>
        <div className='description-container'>
            <div className='skeleton expected-salary'></div>
            <div className='skeleton expected-salary'></div>
        </div>
        <div className='skeleton expected-salary'></div>
        <div className='client-info'>
            <div className='skeleton client-logo'></div>
            <div className='client-details'>
                <div className='skeleton expected-salary'></div>
                <div className='skeleton expected-salary'></div>
            </div>
        </div>
        <Divider />
        {
            [...Array(4)].map((val, index)=> {
                return (
                <TimelineSkeleton key={index} />
                )
            })
        }
    </div>
  )
}

export default JobApplicationStatusContainerSkeleton
